import Vue from 'vue';

Vue.component('dashboard-index', () =>
    import(/* webpackChunkName: 'dashboard-index' */ './dashboard-index.vue'),
);
